"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoLockAccountService = void 0;
const keyring_1 = require("../keyring");
class AutoLockAccountService {
    constructor(kvStore, opts = {
        monitoringInterval: 10000,
    }) {
        this.kvStore = kvStore;
        this.opts = opts;
        // Unit: ms
        this.autoLockDuration = 0;
        this.appStateCheckTimer = null;
        this.autoLockTimer = null;
    }
    init(keyringService) {
        return __awaiter(this, void 0, void 0, function* () {
            this.keyringService = keyringService;
            browser.idle.onStateChanged.addListener((idle) => {
                this.stateChangedHandler(idle);
            });
            yield this.loadDuration();
        });
    }
    stateChangedHandler(newState) {
        if (this.autoLockDuration > 0) {
            if (newState === "locked") {
                this.stopAppStateCheckTimer();
                this.stopAutoLockTimer();
                this.lock();
            }
        }
    }
    startAppStateCheckTimer() {
        this.stopAppStateCheckTimer();
        if (this.autoLockDuration > 0 && this.keyRingIsUnlocked) {
            this.appStateCheckTimer = setTimeout(() => {
                const isAppActive = this.checkAppIsActive();
                if (isAppActive) {
                    this.stopAutoLockTimer();
                    this.startAppStateCheckTimer();
                }
                else {
                    if (this.keyRingIsUnlocked) {
                        this.startAutoLockTimer();
                    }
                    this.stopAppStateCheckTimer();
                }
            }, this.opts.monitoringInterval);
        }
    }
    stopAppStateCheckTimer() {
        if (this.appStateCheckTimer != null) {
            clearTimeout(this.appStateCheckTimer);
            this.appStateCheckTimer = null;
        }
    }
    checkAppIsActive() {
        const background = browser.extension.getBackgroundPage();
        const views = browser.extension.getViews();
        if (background) {
            for (const view of views) {
                if (background.location.href !== view.location.href) {
                    return true;
                }
            }
        }
        else if (views.length > 0) {
            return true;
        }
        return false;
    }
    startAutoLockTimer() {
        if (!this.keyRingIsUnlocked) {
            throw new Error("Keyring is not unlocked");
        }
        if (this.autoLockDuration <= 0) {
            return;
        }
        this.autoLockTimer = setTimeout(() => {
            this.stopAppStateCheckTimer();
            this.stopAutoLockTimer();
            this.lock();
        }, this.autoLockDuration);
    }
    stopAutoLockTimer() {
        if (this.autoLockTimer != null) {
            clearTimeout(this.autoLockTimer);
            this.autoLockTimer = null;
        }
    }
    lock() {
        if (this.keyRingIsUnlocked) {
            this.keyringService.lock();
            const background = browser.extension.getBackgroundPage();
            const views = browser.extension.getViews();
            for (const view of views) {
                // Possibly, keyring can be locked with UI opened. Ex) when device sleep.
                // In this case, to simplify the UI logic, just close all UI.
                if (!background || background.location.href !== view.location.href) {
                    view.close();
                }
            }
        }
    }
    get keyRingIsUnlocked() {
        if (this.keyringService == null) {
            throw new Error("Keyring service is null");
        }
        return this.keyringService.keyRingStatus === keyring_1.KeyRingStatus.UNLOCKED;
    }
    getAutoLockDuration() {
        return this.autoLockDuration;
    }
    setDuration(duration) {
        this.autoLockDuration = duration;
        if (duration <= 0) {
            this.stopAppStateCheckTimer();
            this.stopAutoLockTimer();
        }
        return this.kvStore.set("autoLockDuration", duration);
    }
    loadDuration() {
        return __awaiter(this, void 0, void 0, function* () {
            const duration = yield this.kvStore.get("autoLockDuration");
            if (duration == null) {
                this.autoLockDuration = 0;
            }
            else {
                this.autoLockDuration = duration;
            }
        });
    }
}
exports.AutoLockAccountService = AutoLockAccountService;
//# sourceMappingURL=service.js.map